<button class="btn-type-link existing-files-icon" cygovSvgIcon [svgName]="'upload_collection'"
    [disabled]="totalFiles === 0" ngbTooltip="Existing files" placement="top">
</button>
<div class="circle">{{totalFiles}}</div>